// @flow
import React from 'react';

import { Hero, type Props as HeroProps } from 'Components/widgets/hero/Hero.jsx';

import { FacetSearch } from 'Components/widgets/facet-search/FacetSearch.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';

type Props = {
  ...$Exact<HeroProps>,
  backgroundURL: string,
  displaySearch?: boolean,
  id?: string,
  config: CMSContent,
};

export function ImmersiveLine({
  backgroundURL,
  id,
  displaySearch = false,
  config,
  ...props
}: Props) {
  return (
    <div className="Line Line-Immersive" id={id}>
      <Hero hasOverlap={displaySearch} {...props} url={backgroundURL} />
      {displaySearch && (
        <section className="Line Line-Search">
          <SiteContainer>
            <FacetSearch
              i18n={config}
              searchPageRouteName="search"
              shouldRedirectToResortPage
              withSearchForm
            />
          </SiteContainer>
        </section>
      )}
    </div>
  );
}
